export const environment = {
  production: true,
  TENANT_ID:
    'https://login.microsoftonline.com/8c642d1d-d709-47b0-ab10-080af10798fb', //to change
  CLIENT_ID: 'fc8fd7d8-0a7e-4906-bc8b-56661ee698a6', //to change
  REDIRECT_URL: 'https://perf.newlios.toyota.com',
  log_level: 'error',
  ADMIN_DS_URI: 'https://api.perf.newlios.toyota.com/admin/graphql',
  APM_DS_URI: 'https://api.perf.newlios.toyota.com/apm/graphql',
  BILLING_DS_URI: 'https://api.perf.newlios.toyota.com/billing/graphql',
  OPERATION_DS_URI : "https://api.perf.newlios.toyota.com/operations/graphql",
  MAINTENANCE_DS_URI : "https://api.perf.newlios.toyota.com/maintenance/graphql",
  manifest: {
    admin: 'https://admin.perf.newlios.toyota.com/remoteEntry.js',
    apm: 'https://apm.perf.newlios.toyota.com/remoteEntry.js',
    bm: 'https://bm.perf.newlios.toyota.com/remoteEntry.js',
    lcm: 'https://lcm.perf.newlios.toyota.com/remoteEntry.js',
    cm: 'https://cm.perf.newlios.toyota.com/remoteEntry.js',
    drc: 'https://drc.perf.newlios.toyota.com/remoteEntry.js',
    gc: 'https://generalcosts.perf.newlios.toyota.com/remoteEntry.js',
    ec: 'https://ec.perf.newlios.toyota.com/remoteEntry.js',
    lpi: 'https://lpi.perf.newlios.toyota.com/remoteEntry.js',
    bs: 'https://billingsummary.perf.newlios.toyota.com/remoteEntry.js',
    sur: 'https://sur.perf.newlios.toyota.com/remoteEntry.js',
    maintenance: 'https://maintenance.perf.newlios.toyota.com/remoteEntry.js',
    mshell: 'https://mshell.perf.newlios.toyota.com/remoteEntry.js',
    bshell: 'https://bshell.perf.newlios.toyota.com/remoteEntry.js',
  },
  TASK_MANAGER: 'https://lios.toyota.com/board',
  AET: 'https://ts.portal.toyotasupplier.com/aet',
  ALARMS: 'https://lios.toyota.com/alarms',
  CO2: 'https://lios.toyota.com/co2',
  COST_PLANNING: 'https://lios.toyota.com/costplanning',
  EBOI: 'https://lios.toyota.com/eboi',
  EXPORT: 'https://lios.toyota.com/export',
  GROUPI: 'https://lios.toyota.com/groupi'
};
